<template>
    <div class="flex py-4 sm:py-6 text-black bg-white">
        <div class="flex flex-col items-center w-full px-5 sm:px-10 h-8 sm:h-20 mx-auto sm:flex-row" style="max-width: 1282px">
            <router-link to="/" class="hidden sm:block mb-5 -mt-2 xs:mb-0 xs:mr-auto"><img src="@/assets/img/logo.svg" class="w-auto h-8 sm:h-10 xl:h-12"/></router-link>

            <ul class="flex flex-1 list-style-none w-full sm:w-auto justify-between">
                <li class="flex sm:ml-auto mr-4">
                    <router-link to="/" class="flex items-center font-bold uppercase" :class="$route.path === '/' ? '' : 'opacity-50 grayscale'">
                        <img src="@/assets/img/nav/home.svg" class="w-8 h-8 mr-3 xl:h-10 xl:w-10" />
                        <span class="hidden lg:inline">Accueil</span>
                    </router-link>
                </li>

                <li class="flex mx-4">
                    <router-link to="/activation" class="flex items-center font-bold uppercase" :class="$route.path === '/activation' ? '' : 'opacity-50 grayscale'">
                        <img src="@/assets/img/nav/activation.svg" class="w-8 h-8 mr-3 xl:h-10 xl:w-10" />
                        <span class="hidden lg:inline">Activer mon assurance</span>
                    </router-link>
                </li>

                <li class="flex mx-4">
                    <router-link  :to="isLoggedIn ? '/client' : '/login'" class="flex items-center font-bold uppercase" :class="$route.meta.nav === 'account' ? '' : 'opacity-50 grayscale'">
                        <img src="@/assets/img/nav/account.svg" class="w-8 h-8 mr-3 xl:h-10 xl:w-10" />
                        <div class="flex">
                            <span class="hidden lg:inline">Mon compte</span>
                        </div>
                    </router-link>
                </li>

                <li class="flex ml-4">
                    <router-link to="/faq" class="flex items-center font-bold uppercase" :class="$route.path === '/faq' ? '' : 'opacity-50 grayscale'">
                        <img src="@/assets/img/nav/faq.svg" class="w-8 h-8 mr-3 xl:h-10 xl:w-10"/>
                        <span class="hidden lg:inline">FAQ</span>
                    </router-link>
                </li>
            </ul>
        </div>

        <div class="absolute w-full" style="height: 20px;background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.05), transparent);bottom: -20px;"></div>
    </div>
</template>

<script>
import { isLoggedIn } from '@/auth'

export default {
    data: function () {
        return {
            isOpen: false,
            isLoggedIn: isLoggedIn()
        }
    },
    watch:{
        $route (to, from){
            this.isLoggedIn = isLoggedIn()
        }
    }
}
</script>
